import script from "./CAddCategory.vue?vue&type=script&setup=true&lang=ts"
export * from "./CAddCategory.vue?vue&type=script&setup=true&lang=ts"

import "./CAddCategory.vue?vue&type=style&index=0&id=3fcf9b67&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fcf9b67"]])

export default __exports__